module.exports = __webpack_public_path__ + "static/media/giftsReceived_250_500.fbd0a49f.png";